const messageField = document.querySelector('.js-text-count');
const countOutput = document.querySelector('.js-text-count-output');
const maxLength = parseInt(messageField.getAttribute('maxlength'), 10);

messageField.addEventListener('keyup', () => {
  let count = messageField.value.trim().length;

  if (count > maxLength) {
    messageField.value = messageField.value.substring(0, maxLength);
    count = 250;
  }

  countOutput.textContent = `${count} / ${maxLength} tekens`;
});
